import {WixSdk} from '@wix/js-sdk-wrapper';
import {openPopup} from '../../utils/wix-sdk';
import {disableInEditor} from './featureDisabledPopup';

export const showGetWindow = disableInEditor(({url, onClose}) => {
  openPopup(url, '100%', '100%', onClose, WixSdk.Theme.BARE);
});
